import React from 'react';
import Text from 'Components/Text';

export default ({submittedBy, manufacturerAddress}) => {
  return (
    <section className='scene_section'>
      <header>Contact details</header>
      <Text
        mainWrapperClassName='text__wrapper_primary _margin_right_30'
        textClassName='text__text_primary'
        label='Name'
        value={submittedBy ? `${submittedBy.firstName} ${submittedBy.lastName}` : ''}
      />
      <Text
        mainWrapperClassName='text__wrapper_primary'
        textClassName='text__text_primary'
        label='Email'
        value={submittedBy ? submittedBy.email : ''}
      />
      <Text
        mainWrapperClassName='text__wrapper_primary _width_pc_100'
        textClassName='text__text_primary'
        label='Address'
        value={
          manufacturerAddress
            ? [
              manufacturerAddress.address1,
              manufacturerAddress.address2,
              manufacturerAddress.address3,
              manufacturerAddress.address4,
              manufacturerAddress.city,
              manufacturerAddress.state,
              manufacturerAddress.postalCode,
              manufacturerAddress.country,
            ]
              .filter(object => object)
              .join(', ')
            : 'N/A'
        }
      />
    </section>
  );
}



// WEBPACK FOOTER //
// ./src/app/Scenes/OilManufacturer/brand/Application/Details/ContactDetails.jsx